import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchReviews,
  deleteReview,
} from "../../features/reviews/reviewsSlice.js";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const DashboardReviews = () => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const {
    items: reviews,
    loading,
    error,
  } = useSelector((state) => state.reviews);
  useEffect(() => {
    dispatch(fetchReviews());
  }, [dispatch]);

  const handleDelete = (id) => {
    Swal.fire({
      title: t("dashboardReviews.confirm_delete_title"),
      text: t("dashboardReviews.confirm_delete_text"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#60d8d2",
      cancelButtonColor: "#d33",
      confirmButtonText: t("dashboardReviews.confirm_yes"),
      cancelButtonText: t("dashboardReviews.confirm_cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteReview(id));
        Swal.fire({
          icon: "success",
          title: t("dashboardReviews.deleted"),
          showConfirmButton: false,
          timer: 1500,
        });
      }
    });
  };

  if (loading)
    return <p className="text-center mt-5">{t("dashboardReviews.loading")}</p>;
  if (error)
    return (
      <p className="text-danger text-center">
        {t("dashboardReviews.error")}: {error}
      </p>
    );

  return (
    <div className="container mt-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">
          {t("dashboardReviews.title")}{" "}
          <span className="fs-4">({reviews.length})</span>
        </h4>
        <Link
          to="/AddReview"
          className="btn"
          style={{ backgroundColor: "#60d8d2", color: "#000" }}
        >
          <i className="fa-solid fa-plus mx-2"></i>
          {t("dashboardReviews.add_review")}
        </Link>
      </div>

      {reviews.length > 0 ? (
        <table className="table table-striped table-hover text-center align-middle">
          <thead className="table-light">
            <tr>
              <th>ID</th>
              <th>{t("dashboardReviews.title_col")}</th>
              <th>{t("dashboardReviews.image")}</th>
              <th>{t("dashboardReviews.actions")}</th>
            </tr>
          </thead>
          <tbody>
            {reviews.map((r, i) => (
              <motion.tr
                key={r.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: i * 0.1 }}
              >
                <td>{r.id}</td>
                <td>{isArabic ? r.title_ar : r.title_en}</td>
                <td>
                  <img
                    src={r.image_url}
                    alt={r.title_en}
                    style={{
                      width: "70px",
                      height: "70px",
                      objectFit: "cover",
                      borderRadius: "8px",
                      boxShadow: "0 0 5px #ccc",
                    }}
                  />
                </td>
                <td>
                  <Link
                    to={`/reviews/edit/${r.id}`}
                    className="btn btn-light btn-sm mx-1"
                    title={t("dashboardReviews.edit")}
                  >
                    <i className="fa-solid fa-pen-to-square text-primary"></i>
                  </Link>
                  <button
                    onClick={() => handleDelete(r.id)}
                    className="btn btn-light btn-sm mx-1"
                    title={t("dashboardReviews.delete")}
                  >
                    <i className="fa-solid fa-trash-can text-danger"></i>
                  </button>
                </td>
              </motion.tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className="text-center text-muted fs-5">
          {t("dashboardReviews.no_reviews")}
        </p>
      )}
    </div>
  );
};

export default DashboardReviews;
